var _defs, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocupathLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 474 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        isolation: isolate;\n      }\n\n      .st1 {\n        fill: #173b34;\n      }\n\n      .st2 {\n        fill: url(#linear-gradient);\n      }\n\n      .st3 {\n        fill: #f2faf5;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -60.2,
    y1: 463.2,
    x2: -60.7,
    y2: 462.7,
    gradientTransform: "translate(4656 37060.6) scale(76.1 -80)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#173b34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09a047"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3226",
    className: "st3",
    d: "M0,38.3V15.9c-.1-2.6.4-5.2,1.5-7.5C4.3,3,8.8,0,14.9,0,26.4,0,37.8,0,49.3,0c3.4,0,6.7,1.3,8.9,3.8,4.3,4.4,8.8,8.7,13.2,12.9,2.6,2.4,4.2,5.7,4.6,9.2,0,.5,0,1,0,1.4,0,12.9,0,25.7,0,38.7.2,5.3-2.8,10.2-7.6,12.5-1.8.9-3.8,1.4-5.8,1.4H18.6c-8.5,0-16-5.7-18.1-14-.3-1.4-.5-2.8-.5-4.2,0-8,0-15.8,0-23.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3219",
    className: "st2",
    d: "M0,38.3V15.9c-.1-2.6.4-5.2,1.5-7.5C4.3,3,8.8,0,14.9,0,26.4,0,37.8,0,49.3,0c3.4,0,6.7,1.3,8.9,3.8,4.3,4.4,8.8,8.7,13.2,12.9,2.6,2.4,4.2,5.7,4.6,9.2,0,.5,0,1,0,1.4,0,12.9,0,25.7,0,38.7.2,5.3-2.8,10.2-7.6,12.5-1.8.9-3.8,1.4-5.8,1.4H18.6c-8.5,0-16-5.7-18.1-14-.3-1.4-.5-2.8-.5-4.2,0-8,0-15.8,0-23.6ZM68.8,34.5h-.2c0,0,0,0,0,.2-4.4,9.7-12.1,14.7-22.5,15.8-3.5.4-7,.2-10.6.2-3.9,0-7.8,1.1-11,3.4-3.4,2.3-5.4,6.1-5.4,10.2v8.4h43.5c3.2.1,5.9-2.3,6.2-5.4,0-.6,0-1.1,0-1.7,0-9.4,0-18.9,0-28.4v-2.7ZM7.4,37.7c.2-.3.4-.5.6-.7.2-.2.4-.4.6-.6,4.8-4.4,10.9-7.1,17.4-7.8,3.1-.3,6.3-.4,9.4-.3,1.6,0,3.1,0,4.6-.2,4.3-.5,8-2.9,10.2-6.6.2-.3.3-.8,0-1.1-.4-1.2-.7-2.4-.9-3.6-.2-2.6,0-5.2,0-7.8,0-1.4-.2-1.6-1.5-1.6-4.6,0-9.3-.2-13.9-.2s-12.6,0-18.9,0c-4,0-7.7,2.7-7.7,7.9v8.3c0,4.6,0,9.3,0,14.2h0ZM11.5,69.7v-5.8c0-4.8,1.9-9.5,5.3-12.9,4.7-5,10.8-7.1,17.6-7.3,3.4,0,7,0,10.4-.2,5.6-.4,10.9-3.1,14.5-7.4,2.8-3.3,4.2-7.5,4-11.7,0-.6-.2-.8-.8-.8-1,0-1.8,0-2.8,0-1-.2-2.1.4-2.5,1.4-3.7,6.3-10.4,10.2-17.7,10.5-2.6.2-5.3,0-8,0-6.5-.1-12.8,2.2-17.7,6.5-5,4.2-7.7,9.7-7.3,16.4.1,3.8,1.5,7.4,3.9,10.3.4.3.8.7,1.2,1.1h0ZM57.1,8c0,0-.1,0-.2,0,0,2.3,0,4.6,0,6.9,0,.7.6,1.1,1.4,1.1h6.5c.1,0,.3,0,.4,0-2.8-2.8-5.5-5.4-8.2-8.1Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.2,23.2c13.7,0,21.8,8.2,21.8,22.7s-8.1,23.1-21.8,23.1h-17.6V23.2h17.6ZM114.1,61.1h6.9c8.6,0,13.2-5.2,13.2-15.1s-4.8-14.9-13.2-14.9h-6.9v30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.2,51.5c0-11.2,6.7-18.1,17.2-18.1s17.2,6.9,17.2,18.1-6.6,18.1-17.2,18.1-17.2-6.8-17.2-18.1ZM173.2,51.5c0-6.9-3-10.9-7.8-10.9s-7.8,4.1-7.8,10.9,3,11,7.8,11,7.8-4,7.8-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.5,46.9c-.5-3.6-3-6.2-7.1-6.2s-7.8,4.1-7.8,10.8,3,10.8,7.8,10.8,6.5-2.1,7.1-6h8.6c-.5,8.1-6.6,13.3-15.8,13.3s-17.1-6.9-17.1-18.1,6.7-18.1,17-18.1,15.4,5.7,15.8,13.5h-8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.9,69h-9v-6.3h-.2c-1.8,4.4-5.2,6.8-10.5,6.8-7.6,0-12.5-4.9-12.5-13v-22.4h9.3v20.5c0,4.7,2.3,7.3,6.6,7.3s7-3.1,7-7.8v-19.9h9.3v34.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.7,51.5c0,11.1-5.5,17.9-14.2,17.9s-9-2.3-10.9-6.3h-.2v17.3h-9.3v-46.4h9.1v6h.2c1.8-3.9,5.9-6.4,10.9-6.4,8.9,0,14.3,6.8,14.3,17.9ZM287.2,51.5c0-6.3-3.1-10.4-7.9-10.4s-7.9,4.2-7.9,10.4,3.1,10.4,7.9,10.4,7.9-4.1,7.9-10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.2,58.9c0-6.3,4.9-9.9,13.8-10.5l8.7-.5v-2.3c0-3.4-2.3-5.2-6.1-5.2s-5.7,1.8-6.2,4.3h-8.5c.3-6.7,6.3-11.3,15-11.3s14.9,4.6,14.9,11.6v24h-9v-5.4h-.2c-1.9,3.6-6.2,5.8-10.7,5.8-6.7,0-11.8-4.2-11.8-10.5ZM322.7,56.2v-2.6l-7.3.5c-3.9.3-5.9,1.8-5.9,4.3s2.2,4.2,5.6,4.2,7.7-2.7,7.7-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M349.8,26.3v7.8h6.5v7h-6.5v17c0,2.7,1.3,4,4.2,4s1.7,0,2.3-.2v6.9c-1,.2-2.6.4-4.5.4-8.1,0-11.3-2.7-11.3-9.6v-18.5h-4.7v-7h4.7v-7.8h9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.8,21h9.1v19.3h.2c2-4.4,5.6-6.8,11-6.8,7.7,0,12.2,5,12.2,13.1v22.3h-9.3v-20.4c0-4.6-2.3-7.3-6.7-7.3s-7.3,3.2-7.3,7.9v19.8h-9.3V21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441.6,57.9h-16.1l-3.5,11.1h-9.8l15.9-45.8h11.3l15.9,45.8h-10.2l-3.5-11.1ZM427.5,50.7h12l-5.9-18.8h-.2l-5.9,18.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M459.9,69V23.2h9.6v45.8h-9.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocupathLogo);
export default __webpack_public_path__ + "static/media/Docupath-Logo.c0ee69655ad7425139a3a7b0922d7697.svg";
export { ForwardRef as ReactComponent };